import React from 'react'

import { classNames } from 'app/util/class-names'

export const CardBody: App.FC = ({className, children}) => (
  <div className={classNames('card-body', className)}>
    {children}
  </div>
)